module.exports = __webpack_public_path__ + "img/Uneven Stone Height.1c4e989a.png";